/**
 * 退会手続きフォーム（#member-withdrawal-form）のクライアント側バリデーション
 * visit__fieldError / is-invalid（会員情報の変更・会員登録と同系）
 */

const REASON_TYPES = ['complete_other', 'complete_our', 'stop', 'other'];

function trimValue(id) {
	const el = document.getElementById(id);
	return el ? el.value.trim() : '';
}

function clearErrorForControl(form, controlId) {
	form.querySelectorAll(`.visit__fieldError[data-for="${controlId}"]`).forEach((n) => n.remove());
	const control = document.getElementById(controlId);
	if (!control) return;
	control.removeAttribute('aria-invalid');
	control.classList.remove('is-invalid');
	const wrap = control.closest('.visit__inputWrap--date');
	if (wrap) wrap.classList.remove('is-invalid');
	const schedule = control.closest('.visit__schedule');
	if (schedule) schedule.classList.remove('is-invalid');
	const consent = control.closest('.visit__consent');
	if (consent) consent.classList.remove('is-invalid');
	if (control instanceof HTMLFieldSetElement) {
		return;
	}
}

export function clearMemberWithdrawalFormErrors(form) {
	form.querySelectorAll('.visit__fieldError').forEach((n) => n.remove());
	form.querySelectorAll('.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('.visit__inputWrap--date.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('.visit__schedule.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('.visit__consent.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('.memberWithdrawal__fieldset.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
	form.querySelectorAll('[aria-invalid="true"]').forEach((n) => n.removeAttribute('aria-invalid'));
}

function mountErrorParagraph(controlId, message) {
	const p = document.createElement('p');
	p.className = 'visit__fieldError';
	p.setAttribute('data-for', controlId);
	p.setAttribute('role', 'alert');
	p.textContent = message;
	return p;
}

function showFieldError(form, controlId, message) {
	const control = document.getElementById(controlId);
	if (!control) return;

	clearErrorForControl(form, controlId);

	control.setAttribute('aria-invalid', 'true');
	control.classList.add('is-invalid');

	const wrap = control.closest('.visit__inputWrap--date');
	if (wrap) {
		wrap.classList.add('is-invalid');
		wrap.insertAdjacentElement('afterend', mountErrorParagraph(controlId, message));
		return;
	}

	const schedule = control.closest('.visit__schedule');
	if (schedule) {
		schedule.classList.add('is-invalid');
		schedule.insertAdjacentElement('afterend', mountErrorParagraph(controlId, message));
		return;
	}

	if (control instanceof HTMLFieldSetElement && control.id === 'withdrawal-reason-fieldset') {
		control.appendChild(mountErrorParagraph(controlId, message));
		return;
	}

	control.insertAdjacentElement('afterend', mountErrorParagraph(controlId, message));
}

function focusFirst(controlId) {
	const el = document.getElementById(controlId);
	if (!el) return;
	if (el instanceof HTMLFieldSetElement) {
		const first = el.querySelector('input[type="radio"]');
		if (first instanceof HTMLElement) first.focus();
		return;
	}
	el.focus();
}

/**
 * @returns {boolean}
 */
export function validateMemberWithdrawalForm(form) {
	clearMemberWithdrawalFormErrors(form);

	const errors = [];

	const type = (new FormData(form).get('withdrawal_reason_type') ?? '').toString();
	if (!REASON_TYPES.includes(type)) {
		errors.push(['withdrawal-reason-fieldset', '退会の理由を選択してください。']);
	}

	if (type === 'other') {
		const other = trimValue('withdrawal-reason-other');
		if (!other) {
			errors.push(['withdrawal-reason-other', '「その他」を選択した場合は内容を入力してください。']);
		}
	}

	if (errors.length === 0) {
		return true;
	}

	for (const [id, msg] of errors) {
		showFieldError(form, id, msg);
	}
	focusFirst(errors[0][0]);
	return false;
}

export function initMemberWithdrawalFormValidation(form) {
	if (!form || form.id !== 'member-withdrawal-form') return;

	const onEdit = (e) => {
		const t = e.target;
		if (!t || !form.contains(t)) return;
		if (t.id) {
			clearErrorForControl(form, t.id);
		}
		if (t.matches?.('input[name="withdrawal_reason_type"]')) {
			clearErrorForControl(form, 'withdrawal-reason-fieldset');
		}
	};

	form.addEventListener('input', onEdit);
	form.addEventListener('change', onEdit);
}
